module.exports = __webpack_public_path__ + "static/media/restaurant.86e286cb.svg";